<template>
  <div class="ui form">
    <div class="two fields">
      <div class="field">
        <label>{{ $t("api key") }}</label>
        <input
          type="text"
          name="api_key"
          placeholder=""
          v-model="setup.api_key"
        />
      </div>
      <div class="field">
        <label>{{ $t("ip pool") }}</label>
        <input
          type="text"
          name="ip_pool"
          placeholder=""
          v-model="setup.ip_pool"
        />
      </div>
    </div>
    <div class="two fields">
      <div class="field">
        <label>{{ $t("send from") }}</label>
        <input
          type="text"
          name="from"
          placeholder="example@gomodul.com"
          v-model="setup.from"
        />
      </div>
      <div class="field">
        <label>{{ $t("sender name") }}</label>
        <input
          type="text"
          name="sender_name"
          :placeholder="$t('name')"
          v-model="setup.sender_name"
        />
      </div>
    </div>
  </div>
</template>

<script>
import filters from "@/filters";

export default {
  name: "EmailModal",
  filters: filters,
  components: {},
  computed: {},
  props: { selected_configuration: Object },
  data() {
    return {
      setup: {
        from: "",
        api_key: "",
        ip_pool: "",
        sender_name: "",
      },
    };
  },
  methods: {
    getSetup() {
      return this.setup;
    },
  },
  created() {},
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
      },
    });

    if (vm.selected_configuration) {
      vm.setup = vm.selected_configuration.setup;
      if (vm.setup.is_gmail)
        window.jQuery(vm.$refs.is_gmail).checkbox("set checked");
      if (vm.setup.secure)
        window.jQuery(vm.$refs.secure).checkbox("set checked");
    }

    window.jQuery(vm.$refs.secure).checkbox({
      onChange() {
        vm.setup.secure = window.jQuery(vm.$refs.secure).checkbox("is checked");
      },
    });

    window.jQuery(vm.$refs.is_gmail).checkbox({
      onChange() {
        vm.setup.is_gmail = window
          .jQuery(vm.$refs.is_gmail)
          .checkbox("is checked");
      },
    });

    /**
     * Tabs initialization
     */
    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
  watch: {
    "setup.is_gmail": function() {
      let value = this.setup.is_gmail;
      if (value) this.setup.host = "gmail";
    },
  },
};
</script>
